






import { defineComponent, computed } from '@vue/composition-api'
import { formatTime, parseTime } from '@/lib/format-time'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default defineComponent({
  components: {
    VueTimepicker
  },

  props: {
    value: Number
  },

  setup(props, { emit }) {
    const time = computed({
      get: () => formatTime(props.value),
      set: value => emit('input', parseTime(value))
    })

    return {
      time
    }
  }
})
